import styled from "styled-components";

const Container = styled.div`
  border-radius: 0 2em 0 2em;
  overflow: hidden;
  width: 100%;
  cursor: pointer;

  @media (max-width: 576px) {
  }

  &:hover {
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    transition: box-shadow 0.3s ease-in-out;
  }
`;
const Thumbnail = styled.img`
  width: 100%;
  height: 240px;
  object-fit: cover;

  @media screen and (min-width: 767px) and (max-width: 991px){
    height: 143px;
  }
  @media screen and (max-width: 767px){
    height: 143px;
  }
`;
const Description = styled.div`
  bottom: 0;
  left: 0;
`;
const Title = styled.div`
  font-size: 1em;
  font-weight: 600;
`;

const Gradient = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #6c6b6bbd, #ffffff00);
  position: absolute;
`;

const LinkImage = (props) => {
  return (
    <Container className="position-relative overflow-hidden mb-4">
      <Gradient />
      <Thumbnail src={props.image} />
      <Description className="position-absolute text-start p-4 text-light">
        <Title>{props.label}</Title>
      </Description>
    </Container>
  );
};

export default LinkImage;
